import { Component, Input, ViewEncapsulation } from '@angular/core';
import { NkNavVerticalGroupComponent } from './vertical/nav-group/nav-vertical-group.component';
import { NkNavVerticalCollapseComponent } from './vertical/nav-collapse/nav-vertical-collapse.component';
import { NkNavVerticalItemComponent } from './vertical/nav-item/nav-vertical-item.component';
import { NkNavHorizontalCollapseComponent } from './horizontal/nav-collapse/nav-horizontal-collapse.component';
import { NkNavHorizontalItemComponent } from './horizontal/nav-item/nav-horizontal-item.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports:[
    NkNavVerticalGroupComponent,
    NkNavVerticalCollapseComponent,
    NkNavVerticalItemComponent,
    NkNavHorizontalCollapseComponent,
    NkNavHorizontalItemComponent,
    CommonModule,
  ]
})
export class NkNavigationComponent {
  @Input() layout = 'vertical';
  @Input() navigation: any;
}
